import React from "react";
import ReactDOM from "react-dom";
// import './index.css';
import "assets/scss/material-kit-react.css?v=1.3.0";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import indexRoutes from "routes/index.jsx";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

// ReactDOM.render(<App />, document.getElementById('root'));
// serviceWorker.unregister();
var hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      {indexRoutes.map((prop, key) => {
        return <Route path={prop.path} key={key} component={prop.component} />;
      })}
    </Switch>
  </Router>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js